define('customersDetailHeaderView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'bootbox',
  'imageUtils',
  'buttonView',
  'usersView',
  'companiesLinkView',
  'tasksCreatorBehavior',
  'template!customersDetailHeaderView',
  'entities/prospection'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  bootbox,
  ImageUtils,
  ButtonView,
  UsersView,
  CompaniesLinkView,
  TasksCreatorBehavior,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'customers-detail-header-view',

    ui: {
      logo: '.logo',
      type: '.infos .type',
      prospectionStatus: '.js-prospection-status',
      name: '.infos .name',
      clientName: '.infos .client-name',
      number: '.infos .number',
      code: '.infos .code',
      phone: '.phone',
      phoneValue: '.phone .value',
      mail: '.mail',
      mailValue: '.mail .value',
      vatValid: '.vat-valid',
      notificationsEnabled: '.notifications .enabled',
      notificationsDisabled: '.notifications .disabled'
    },

    events: {
      'click @ui.prospectionStatus': 'onProspection',
      'click @ui.notificationsEnabled': 'onEnabledNotifications',
      'click @ui.notificationsDisabled': 'onDisabledNotifications',
      'click @ui.phone': 'onPhoneClick'
    },

    modelEvents: {
      'change:logoUid': 'renderLogo',
      'change:code': 'renderLogo',
      'change:userType': 'renderType',
      'change:name': 'renderContent',
      'change:firstName': 'renderContent',
      'change:lastName': 'renderContent',
      'change:tel': 'renderContent',
      'change:email': 'renderContent',
      'change:subjectToVat': 'renderContent',
      'change:vatNumberChecked': 'renderContent'
    },

    regions: {
      backRegion: '.back-region',
      convertRegion: '.convert-region',
      prospectionRegion: '.prospection-region',
      usersRegion: '.users-region',
      companyRegion: '.company-region'
    },

    behaviors: function () {
      return {
        CreateTask: {
          behaviorClass: TasksCreatorBehavior,
          refEndUser: this.options.model
        }
      };
    },

    onShow: function () {
     this.backButtonView = new ButtonView({
        type: 'list',
        text: _.i18n('common.back.to.list'),
        title: _.i18n('common.back.to.list')
      });

      this.backRegion.show(this.backButtonView);
      this.backButtonView.on('click', _.bind(this.onBackList, this));

      //--------------------
      this.convertButtonView = new ButtonView({
        type: 'add-user',
        text: _.i18n('menu.convertToCustomer', null, 'Convert to customer'),
        title: _.i18n('menu.convertToCustomer', null, 'Convert to customer')
      });
      this.getRegion('convertRegion').show(this.convertButtonView);
      this.convertButtonView.on('click', _.bind(this.onConvertToCustomer, this));
      this.renderType();

      //--------------------
      // Prospection: "add to the board" when the customer is not on it yet,
      // "open in prospection" when it is. One button, two labels.
      this.prospectionButtonView = new ButtonView({
        type: 'goto',
        text: _.i18n('prospection.addTo', null, 'Add to prospection'),
        title: _.i18n('prospection.addTo', null, 'Add to prospection')
      });
      this.getRegion('prospectionRegion').show(this.prospectionButtonView);
      this.prospectionButtonView.on('click', _.bind(this.onProspection, this));
      this.loadProspection();

      //--------------------
      this.usersView = new UsersView({
        model: new Backbone.Model({userpids: this.model.get('userpids')}),
        onSelected: _.bind(function (user) {
          var deferred = new $.Deferred();
          this.model.assignUser(user.get('secId')).done(_.bind(function () {
            this.model.fetch();
            deferred.resolve();
          }, this));
          return deferred;
        }, this),
        onUnSelected: _.bind(function (user) {
          var deferred = new $.Deferred();
          this.model.unassignUser(user.get('secId')).done(_.bind(function () {
            this.model.fetch();
            deferred.resolve();
          }, this));
          return deferred;
        }, this)
      });
      this.getRegion('usersRegion').show(this.usersView);

      //--------------------
      this.companyView = new CompaniesLinkView({
        model: this.model
      });
      this.getRegion('companyRegion').show(this.companyView);
    },

    onRender: function () {
      this.renderLogo();
      this.renderType();
      this.renderContent();
      this.renderNotification();
      // A re-render rebuilds the (empty) status strip: paint it again from what we know.
      if (this.prospection) { this.renderProspectionStatus(); }
    },

    renderType: function () {
      var isLead = this.model.isLead();

      this.ui.type
        .toggleClass('lead', isLead)
        .toggleClass('customer', !isLead)
        .html(isLead ? _.i18n('endUser.type.lead', null, 'Lead') : _.i18n('endUser.type.customer', null, 'Customer'));

      if (this.convertButtonView)
        this.convertButtonView.$el.toggle(isLead);
    },

    renderLogo: function () {
      var logo = ImageUtils.getLogo(this.model.get('logoUid'), this.model.get('code'));
      if(logo) {
        this.ui.logo.css('background-image', 'url(' + logo + ')');
      } else {
        this.ui.logo.addClass('default-upload-image');
      }
    },

    renderContent: function () {
      this.ui.name.html('');
      if(this.model.get('name'))
        this.ui.name.html(this.model.get('name'));

      //--------------------------

      var html = '';
      if(this.model.get('firstName'))
        html += this.model.get('firstName');

      if(this.model.get('lastName')) {
        if(html !== ' ')
          html += ' ';

        html += this.model.get('lastName');
      }

      this.ui.clientName.html(html);

      //--------------------------

      this.ui.number.html('');
      if(this.model.getCustomerNumber())
        this.ui.number.html('N°: ' + this.model.getCustomerNumber());

      //--------------------------

      this.ui.phone.hide();
      this.ui.phoneValue.html('');
      if(this.model.get('tel')) {
        this.ui.phoneValue.html(this.model.get('tel'));
        this.ui.phone.css('display', 'flex');
      }

      //--------------------------

      this.ui.mail.hide();
      this.ui.mailValue.html('');
      if(this.model.get('email')) {
        this.ui.mailValue.html(this.model.get('email'));
        this.ui.mail.css('display', 'flex');
      }

      //--------------------------

      this.ui.vatValid.hide();
      if(this.model.get('subjectToVat') && !this.model.get('vatNumberChecked'))
        this.ui.vatValid.css('display', 'flex');
    },

    renderNotification: function () {
     $.when(App.request('customer:is-user-notified', this.model.get('secId')).done(_.bind(function (res) {
        if (res > 0) {
          this.ui.notificationsEnabled.css('display', 'flex');
          this.ui.notificationsDisabled.hide();
        } else {
          this.ui.notificationsEnabled.hide();
          this.ui.notificationsDisabled.css('display', 'flex');
        }
      }, this)));
    },

    onEnabledNotifications: function () {
      $.when(App.request('customer:notify-me', this.model.get('secId'), false).done(_.bind(function () {
        this.renderNotification();
      }, this)));
    },

    onDisabledNotifications: function () {
      $.when(App.request('customer:notify-me', this.model.get('secId'), true).done(_.bind(function () {
          this.renderNotification();
      }, this)));
    },

    onPhoneClick: function (e) {
      e.stopPropagation();
      App.trigger('phone:numbering', {
        phoneNumber: this.model.get('tel'),
        country: this.model.get('countryCode')
      });
    },

    loadProspection: function () {
      var secId = this.model.get('secId');
      if (!secId) { return; }
      if (!this.prospectionListening) {
        this.prospectionListening = true;
        // The prospect window (or the board) changed the file: reflect it here too.
        this.listenTo(App, 'prospection:updated', function (json) {
          if (json && this.prospection && json.secId === this.prospection.secId) {
            this.prospection = json;
            this.renderProspectionButton();
          }
        });
        this.listenTo(App, 'prospection:removed', function (secId) {
          if (this.prospection && this.prospection.secId === secId) {
            this.prospection = null;
            this.renderProspectionButton();
          }
        });
      }
      App.request('prospection:by-customer', secId).done(_.bind(function (json) {
        if (this.isDestroyed) { return; }
        this.prospection = json || null;
        this.renderProspectionButton();
      }, this));
    },

    renderProspectionButton: function () {
      if (!this.prospectionButtonView) { return; }
      var label = this.prospection ?
        _.i18n('prospection.openIn', null, 'Open in prospection') :
        _.i18n('prospection.addTo', null, 'Add to prospection');
      this.prospectionButtonView.$el.attr('title', label).find('.text').text(label);
      this.renderProspectionStatus();
    },

    // The prospecting state, right in the header: stage, owner, what the phone
    // and email gave, what is planned next. Hidden when the customer is not on
    // the board. Click opens the prospect window.
    renderProspectionStatus: function () {
      var p = this.prospection;
      if (!p) {
        this.ui.prospectionStatus.hide().empty();
        return;
      }
      var stageLabels = {
        NEW: _.i18n('prospection.stage.NEW', null, 'New'),
        CONTACTED: _.i18n('prospection.stage.CONTACTED', null, 'Contacted'),
        INTERESTED: _.i18n('prospection.stage.INTERESTED', null, 'Interested'),
        QUOTE_SENT: _.i18n('prospection.stage.QUOTE_SENT', null, 'Quote sent'),
        ON_HOLD: _.i18n('prospection.stage.ON_HOLD', null, 'On hold'),
        WON: _.i18n('prospection.stage.WON', null, 'Won'),
        LOST: _.i18n('prospection.stage.LOST', null, 'Lost')
      };
      var phoneLabels = {
        NOT_CALLED: _.i18n('prospection.phone.NOT_CALLED', null, 'Not called'),
        NO_ANSWER: _.i18n('prospection.phone.NO_ANSWER', null, 'No answer'),
        VOICEMAIL: _.i18n('prospection.phone.VOICEMAIL', null, 'Voicemail'),
        CALLBACK: _.i18n('prospection.phone.CALLBACK', null, 'Call back'),
        REACHED: _.i18n('prospection.phone.REACHED', null, 'Reached'),
        REFUSED: _.i18n('prospection.phone.REFUSED', null, 'Refused'),
        WRONG_NUMBER: _.i18n('prospection.phone.WRONG_NUMBER', null, 'Wrong number')
      };
      var emailLabels = {
        NOT_SENT: _.i18n('prospection.email.NOT_SENT', null, 'Not sent'),
        SENT: _.i18n('prospection.email.SENT', null, 'Sent'),
        FOLLOW_UP: _.i18n('prospection.email.FOLLOW_UP', null, 'Follow-up sent'),
        REPLIED: _.i18n('prospection.email.REPLIED', null, 'Replied'),
        BOUNCED: _.i18n('prospection.email.BOUNCED', null, 'Bounced'),
        REFUSED: _.i18n('prospection.email.REFUSED', null, 'Refused')
      };
      var goodPhone = { REACHED: 1, CALLBACK: 1 };
      var badPhone = { REFUSED: 1, WRONG_NUMBER: 1 };
      var goodEmail = { REPLIED: 1 };
      var badEmail = { BOUNCED: 1, REFUSED: 1 };
      var stage = String(p.stage || 'NEW');
      var owner = p.assignedUser ?
        $.trim((p.assignedUser.firstName || '') + ' ' + (p.assignedUser.lastName || '')) || p.assignedUser.logonId || '' :
        '';
      var next = '';
      var nextTone = '';
      if (p.nextActionAt) {
        var d = new Date(p.nextActionAt);
        next = isNaN(d.getTime()) ? '' : d.toLocaleDateString('fr-BE', { day: '2-digit', month: '2-digit', year: 'numeric' });
        nextTone = p.overdue ? 'late' : (p.nextActionInDays === 0 ? 'today' : '');
      }
      var html =
        '<span class="ps-label">' + _.i18n('menu.prospection', null, 'Prospection') + '</span>' +
        '<span class="ps-pill stage st-' + stage.toLowerCase().replace(/_/g, '-') + '">' + _.escape(stageLabels[stage] || stage) + '</span>' +
        '<span class="ps-pill ' + (goodPhone[p.phoneStatus] ? 'good' : (badPhone[p.phoneStatus] ? 'bad' : '')) + '" title="' +
          _.i18n('prospection.col.phone', null, 'Phone') + '"><i class="fa fa-phone"></i>' + _.escape(phoneLabels[p.phoneStatus] || '') +
          (p.phoneAttempts ? ' ×' + p.phoneAttempts : '') + '</span>' +
        '<span class="ps-pill ' + (goodEmail[p.emailStatus] ? 'good' : (badEmail[p.emailStatus] ? 'bad' : '')) + '" title="' +
          _.i18n('prospection.col.email', null, 'Email') + '"><i class="fa fa-envelope-o"></i>' + _.escape(emailLabels[p.emailStatus] || '') +
          (p.emailAttempts ? ' ×' + p.emailAttempts : '') + '</span>' +
        (next ? '<span class="ps-pill next ' + nextTone + '" title="' + _.escape(p.nextActionNote || '') + '"><i class="fa fa-clock-o"></i>' + next + '</span>' : '') +
        (owner ? '<span class="ps-owner" title="' + _.i18n('prospection.col.owner', null, 'Owner') + '"><i class="fa fa-user"></i>' + _.escape(owner) + '</span>' :
          '<span class="ps-owner none">' + _.i18n('prospection.nobody', null, 'Nobody') + '</span>') +
        '<span class="ps-score" title="' + _.escape(p.scoreReason || '') + '">' + (p.score || 0) + '</span>';
      this.ui.prospectionStatus.html(html)
        .attr('title', _.i18n('prospection.openIn', null, 'Open in prospection'))
        .show();
    },

    onProspection: function () {
      var secId = this.model.get('secId');
      if (!secId) { return; }
      if (this.prospection && this.prospection.secId) {
        App.trigger('prospection:show', this.prospection.secId);
        return;
      }
      this.prospectionButtonView.enabled(false);
      App.request('prospection:enroll', { endUserSecIds: [secId] }).done(_.bind(function (result) {
        if (this.isDestroyed) { return; }
        this.prospectionButtonView.enabled(true);
        var created = (result && result.items) || [];
        if (created.length) {
          this.prospection = created[0];
          this.renderProspectionButton();
          App.trigger('prospection:show', created[0].secId);
        }
      }, this)).fail(_.bind(function () {
        if (!this.isDestroyed) { this.prospectionButtonView.enabled(true); }
      }, this));
    },

    onConvertToCustomer: function () {
      if (!this.model.isLead())
        return;

      bootbox.confirm(_.i18n('leads.convertToCustomer.confirm', null, 'Convert this lead into a customer?'), _.bind(function (result) {
        if (!result)
          return;

        this.model.convertToCustomer().done(_.bind(function () {
          App.navigate('customers/' + this.model.get('secId') + '/profile', {trigger: true});
        }, this));
      }, this));
    },

    onBackList: function () {
      App.navigate(this.model.getRoute(), {trigger: true});
    }
  });
});
